import React from "react";

function HomeHeroCarousel() {
  const heroSlides = [
    {
      id: 1,
      desktopImage: "/s3/wrestling-dec.jpg",
      mobileImage: "/s3/wrestling-dec-mobile.jpg",
      alt: "Live Wrestling",
      link: "https://tickets.adssportscomplex.com/48e0f1f1-81f4-4ee6-8ca4-85f9c98f586c"
    },
    {
      id: 2,
      desktopImage: "/s3/volleyball-camps-aug.jpg",
      mobileImage: "/s3/volleyball-camps-aug-mobile.jpg",
      alt: "ADS Volleyball Camps",
      link: "/Volleyball"
    },
    {
      id: 3,
      desktopImage: "/s3/basketball-camps-aug.jpg",
      mobileImage: "/s3/basketball-camps-aug-mobile.png",
      alt: "ADS Basketball Camps",
      link: "/Basketball"
    },
    {
      id: 4,
      desktopImage: "/s3/train-bumper-rentals.jpg",
      mobileImage: "/s3/train-bumper-rentals-mobile.png",
      alt: "Train and Bumper Car Rentals",
    },
    
  ];

  return (
    <section className="home-hero">
      <div
        id="homeHeroCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="6000"
      >
        <div className="carousel-inner">
          {heroSlides.map((slide, index) => (
            <div
              className={`carousel-item ${
                index === 0 ? "active" : ""
              }`}
              key={slide.id}
            >
              {slide.link ? (
                <a href={slide.link}>
                  <picture>
                    <source
                      media="(max-width: 767.98px)"
                      srcSet={slide.mobileImage}
                    />

                    <img
                      src={slide.desktopImage}
                      className="d-block w-100 home-hero-image"
                      alt={slide.alt}
                    />
                  </picture>
                </a>
              ) : (
                <picture>
                  <source
                    media="(max-width: 767.98px)"
                    srcSet={slide.mobileImage}
                  />

                  <img
                    src={slide.desktopImage}
                    className="d-block w-100 home-hero-image"
                    alt={slide.alt}
                  />
                </picture>
              )}
            </div>
          ))}
        </div>

        {heroSlides.length > 1 && (
          <>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#homeHeroCarousel"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>

              <span className="visually-hidden">
                Previous
              </span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#homeHeroCarousel"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>

              <span className="visually-hidden">
                Next
              </span>
            </button>
          </>
        )}
      </div>
    </section>
  );
}

export default HomeHeroCarousel;